export interface IProfileDetails {
  avatar: string
  fName: string
  lName: string
  company: string
  contactPhone: string
  companySite: string
  country: string
  language: string
  timeZone: string
  currency: string
  communications: {
    email: boolean
    phone: boolean
  }
  allowMarketing: boolean
}


export interface IFormCarga {
  fileIndicadores: any
  fileCompromisos: any
}

export interface IUpdateEmail {
  newEmail: string
  confirmPassword: string
}

export interface IUpdatePassword {
  currentPassword: string
  newPassword: string
  passwordConfirmation: string
}

export interface IConnectedAccounts {
  google: boolean
  github: boolean
  stack: boolean
}

export interface IEmailPreferences {
  successfulPayments: boolean
  payouts: boolean
  freeCollections: boolean
  customerPaymentDispute: boolean
  refundAlert: boolean
  invoicePayments: boolean
  webhookAPIEndpoints: boolean
}

export interface INotifications {
  notifications: {
    email: boolean
    phone: boolean
  }
  billingUpdates: {
    email: boolean
    phone: boolean
  }
  newTeamMembers: {
    email: boolean
    phone: boolean
  }
  completeProjects: {
    email: boolean
    phone: boolean
  }
  newsletters: {
    email: boolean
    phone: boolean
  }
}

export interface IDeactivateAccount {
  confirm: boolean
}

export interface CrearUsuarioModel {
  email: string,
  nombre: string,
  perfil: string,
  centroResponsable: string | null,
  indicadores: Array<number> | null
}

export interface EditarPeriodoModel {
  id: number,
  FechaFin: string | null,
  FechaInicio: string | null
  Estado: string | null,
}

export interface EditarUsuarioModel {
  idUsuario: number,
  email: string,
  nombre: string,
  perfil: string,
  centroResponsable: string | null,
  indicadores: Array<number> | null,
  activo: string
}

export interface EditarIndicadorModel {
  agnoFiltro: number,
  idIndicador: number | null,
  nombre: string,
  version: string,
  etiqueta: string | null,
  descripcion: string,
  idArea: number | null,
  idTipoValor: number | null,
  formula: string,
  ordenDespliegue: number | null | string,
  agno: number | null,
  lectura: string,
  idTipoIndicador: number | null,
  queryFechaCorte: string,
  query: string,
  idTipoCarga: number | null,
  baseFija: number | null,
  idCategoria: Array<number> | null
}

export const editarPeriodoInitValues: EditarPeriodoModel = {
  id: 0,
  FechaFin: null,
  FechaInicio: null,
  Estado:null
}

export const editarUsuarioInitValues: EditarUsuarioModel = {
  email: '',
  nombre: '',
  perfil: '',
  centroResponsable: null,
  indicadores: null,
  activo: '0',
  idUsuario: 0
}

export const editarIndicadorInitValues: EditarIndicadorModel = {
  agnoFiltro: new Date().getFullYear(),
  idIndicador: null,
  nombre: '',
  version: '',
  etiqueta: '',
  descripcion: '',
  idArea: null,
  idTipoValor: null,
  formula: '',
  ordenDespliegue: null,
  agno: null,
  lectura: '',
  idTipoIndicador: null,
  queryFechaCorte: '',
  query: '',
  idTipoCarga: null,
  baseFija: null,
  idCategoria: null
}

export const cargaInitValues: IFormCarga = {
  fileIndicadores: null,
  fileCompromisos: null
}

export const crearUsuarioInitValues: CrearUsuarioModel = {
  email: '',
  nombre: '',
  perfil: '',
  centroResponsable: null,
  indicadores: null
}

export const profileDetailsInitValues: IProfileDetails = {
  avatar: '/media/avatars/300-1.jpg',
  fName: 'Max',
  lName: 'Smith',
  company: 'Keenthemes',
  contactPhone: '044 3276 454 935',
  companySite: 'keenthemes.com',
  country: '',
  language: '',
  timeZone: '',
  currency: '',
  communications: {
    email: false,
    phone: false,
  },
  allowMarketing: false,
}

export const updateEmail: IUpdateEmail = {
  newEmail: 'support@keenthemes.com',
  confirmPassword: '',
}

export const updatePassword: IUpdatePassword = {
  currentPassword: '',
  newPassword: '',
  passwordConfirmation: '',
}

export const connectedAccounts: IConnectedAccounts = {
  google: true,
  github: true,
  stack: false,
}

export const emailPreferences: IEmailPreferences = {
  successfulPayments: false,
  payouts: true,
  freeCollections: false,
  customerPaymentDispute: true,
  refundAlert: false,
  invoicePayments: true,
  webhookAPIEndpoints: false,
}

export const notifications: INotifications = {
  notifications: {
    email: true,
    phone: true,
  },
  billingUpdates: {
    email: true,
    phone: true,
  },
  newTeamMembers: {
    email: true,
    phone: false,
  },
  completeProjects: {
    email: false,
    phone: true,
  },
  newsletters: {
    email: false,
    phone: false,
  },
}

export const deactivateAccount: IDeactivateAccount = {
  confirm: false,
}
